import React from 'react';
function ErrorSpan({ error }) { if (!error || Array.isArray(error) && error.length == 0)
    return null; const spanProps = { className: 'form-group__error-message' }; let errorChildren; if (Array.isArray(error)) {
    errorChildren = error.map((error, index) => { return /*#__PURE__*/ React.createElement("span", { className: "help-block", key: index }, error); });
}
else {
    spanProps.dangerouslySetInnerHTML = { __html: error };
} return /*#__PURE__*/ React.createElement("span", spanProps, errorChildren); }
export default ErrorSpan;
